import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAnnouncement = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/announcement-banners`
    );

    return data;
};

export const saveAnnouncementBanner = async (payload: any) => {
    const { data } = await http.post(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/announcement-banners`,
        payload
    );
};
